import React, { FC } from "react";
import { ConfirmProvider as MuiConfirmProvider } from "material-ui-confirm";

export interface ConfirmProviderProps {}

const ConfirmProvider: FC<ConfirmProviderProps> = ({ children }) => {
  return <MuiConfirmProvider>{children}</MuiConfirmProvider>;
};

export default ConfirmProvider;
